import { getCountryCallingCode } from 'react-phone-number-input';
import { CommandItem } from '../../../../Command';
import { FlagComponent } from '../../FlagComponent';
import { countrySelectItem } from '../styles';
import { type OptionProps } from './types';

export const Option = ({
  country,
  countryName,
  onChange,
  onSelectComplete,
}: OptionProps): React.ReactElement => {
  const countryCallingCode = `+${getCountryCallingCode(country)}`;

  const handleSelect = (): void => {
    onChange(country);
    onSelectComplete();
  };

  return (
    <CommandItem className={countrySelectItem} onSelect={handleSelect}>
      <div className="flex flex-1 items-center gap-2">
        <FlagComponent country={country} countryName={countryName} />
        <span className="text-sm">{countryName}</span>
      </div>
      <span className="text-sm">{countryCallingCode}</span>
    </CommandItem>
  );
};
